import { CreditCardFieldConfig } from "@evergiving/common/dist/es2015/form";

import { FormField } from "@/lib/components/FormField";
import { LabelledField } from "@/lib/components/LabelledField";
import { LabelText } from "@/lib/components/LabelText";

import { CardExpiryField } from "./CardExpiryField";
import { CreditCardNumberField } from "./CreditCardNumberField";

export type FormFieldsCreditCardProps = {
  creditCardFieldConfig: CreditCardFieldConfig;
};

export const FormFieldsCreditCard = ({
  creditCardFieldConfig,
}: FormFieldsCreditCardProps) => (
  <>
    <FormField
      config={creditCardFieldConfig.cardHolder}
      name="cardHolder"
      htmlName="ccname"
      autoComplete="cc-name"
    />
    <CreditCardNumberField config={creditCardFieldConfig.cardNumber} />
    <LabelledField id="cardExpiryDate">
      <LabelText requiredIndicator>
        {creditCardFieldConfig.cardExpiry.labelText}
      </LabelText>
      <CardExpiryField config={creditCardFieldConfig.cardExpiry} />
    </LabelledField>
    {creditCardFieldConfig.cvc && (
      <FormField
        config={creditCardFieldConfig.cvc}
        name="cardVerificationCode"
        htmlName="cvc"
        autoComplete="cc-csc"
      />
    )}
  </>
);
